export default __webpack_public_path__ + "static/media/logo-icon.b963dea4.svg";